import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'utcdatetime'
})
export class UtcdatetimePipe implements PipeTransform {

  transform(value: Date, p: number): string {
    if (value) {
      switch (p) {
        case 0:
          return moment.utc(value).format('MMM,DD YYYY');
        case 1:
          return moment.utc(value).format('MMM,DD YYYY LTS');
        case 2:
          return moment.utc(value).format('MMM,DD YYYY HH:mm:ss');
        case 3:
          return moment.utc(value).format('YYYY-MM-DD h:mm a');
        case 4:
          return moment.utc(value).format('YYYY-MM-DD HH:mm');
        default:
          return moment.utc(value).format('MMM,DD YYYY LTS');
      }
    }
    return '';
  }

}
